import { render, staticRenderFns } from "./FlagButton.vue?vue&type=template&id=29c15f30&"
import script from "./FlagButton.vue?vue&type=script&lang=js&"
export * from "./FlagButton.vue?vue&type=script&lang=js&"
import style0 from "./FlagButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports